module.exports = __webpack_public_path__ + "img/blpjs01_center_005.2346b6f0.png";